/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'save': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M296.896 774.406h116.672v189.319H296.896V774.406z"/><path pid="1" d="M940.888.038H22.875C10.725.038.877 9.888.877 22.037v794.821L147.983 962.05h67.18V681.556h442.481v280.369h-.69v.124h283.934c12.15 0 21.999-9.849 21.999-21.998V22.037c0-12.15-9.848-21.999-21.999-21.999zM809.34 484.168H154.424V52.695H809.34V484.17z"/><path pid="2" d="M296.896 961.926h116.672v6.4H296.896z"/>'
  }
})
